module.exports = __webpack_public_path__ + "bfeadb02a0e0566b376450d23682c523.svg";